module.exports = __webpack_public_path__ + "img/bag.79348a24.jpg";